// @ts-nocheck
import Breadcrumbs from "@insite/mobius/Breadcrumbs";
import { LinkProps } from "@insite/mobius/Link";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC } from "react";
import { css } from "styled-components";

const links: LinkProps[] = [
    { children: "Home", href: "#" },
    { children: "Category", href: "#" },
    { children: "SubCategory", href: "#" },
    { children: "Current Page", href: "#" },
];

const StyleguideBreadcrumbs: FC = () => {
    const breadcrumbsCss = css`
        padding: 0 !important;
        ${x => x.theme.breadcrumbs.defaultProps?.css}
    `;

    return (
        <StyleguideSection title="Breadcrumbs">
            <Breadcrumbs links={links} css={breadcrumbsCss} />
        </StyleguideSection>
    );
};

export default StyleguideBreadcrumbs;
